// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"727c75cc","616":"77292832","770":"dc16bcc1"}[chunkId] + ".chunk.js";
};